// src/core/platform/webBridge.ts
// 웹 폴백 브릿지 — Electron/Capacitor 둘 다 아닌 경우

import type { PlatformBridge, PlatformFeature, SaveDialogOptions, SaveDialogResult } from "./platformBridge"

/** 웹에서 사용 가능한 기능 (파일 다이얼로그 제한적 지원) */
const WEB_AVAILABLE_FEATURES: PlatformFeature[] = ["file-dialog"]

export class WebBridge implements PlatformBridge {
  readonly platform = "web" as const

  isFeatureAvailable(feature: PlatformFeature): boolean {
    return WEB_AVAILABLE_FEATURES.includes(feature)
  }

  // ── 파일 관련 ──

  async showSaveDialog(_options?: SaveDialogOptions): Promise<SaveDialogResult> {
    // 웹에서는 File System Access API 또는 download 링크 사용
    return { canceled: true }
  }

  async writeFile(_path: string, _content: string) {
    console.warn("[WebBridge] writeFile: 웹 환경에서 미지원")
    return { success: false, error: "Web 환경에서 파일 쓰기 미지원" }
  }

  async writeBinaryFile(_path: string, _data: Uint8Array | ArrayBuffer) {
    console.warn("[WebBridge] writeBinaryFile: 웹 환경에서 미지원")
    return { success: false, error: "Web 환경에서 바이너리 파일 쓰기 미지원" }
  }

  async openFileLocation(_filePath: string) {
    console.warn("[WebBridge] openFileLocation: 웹 환경에서 미지원")
    return { success: false, error: "Web 환경에서 폴더 열기 미지원" }
  }

  // ── 앱 제어 ──

  async openExternalUrl(url: string) {
    window.open(url, "_blank", "noopener,noreferrer")
  }

  async restartApp() {
    window.location.reload()
  }

  async exitApp() {
    window.close()
  }

  // ── 서버 검색 ──

  async scanNetwork() {
    return []
  }

  async checkServer(ip: string, port: number) {
    try {
      const response = await fetch(`https://${ip}:${port}/health/`, {
        method: "GET",
        signal: AbortSignal.timeout(3000),
      })
      return response.ok
    } catch {
      return false
    }
  }

  async getLocalIp() {
    return null
  }

  async saveProxyConfig(_config: unknown) {
    if (_config && typeof _config === "object") {
      localStorage.setItem("SigmaServerConfig", JSON.stringify(_config))
    }
  }
}

